<template>
    <base-box background-color="grey" class="margin-bottom-large">
        <template #content>
            <div v-if="tags.hashtag.length > 0" class="no-margins">
                <g-typography tag="span" font-weight="semibold"> Hashtag in the captions: </g-typography>
                <g-typography tag="span" :value="tags.hashtag" />
            </div>
            <div v-if="tags.mention.length > 0" class="no-margins">
                <g-typography tag="span" font-weight="semibold"> Mention in the caption: </g-typography>
                <g-typography tag="span" :value="tags.mention" />
            </div>
            <div v-if="tagPost" class="no-margins">
                <g-typography tag="span" font-weight="semibold"> Tag in the post: </g-typography>
                <g-typography tag="span" :value="tagPost" />
            </div>
        </template>
    </base-box>
</template>

<script>
    import trimEnd from 'lodash/trimEnd';

    export default {
        name: 'TagsBox',
        props: {
            tags: {
                type: Object,
                default: null
            },
            customDescription: {
                type: String,
                default: undefined
            },
            tagPost: {
                type: String,
                default: ''
            }
        },
        computed: {
            description() {
                return this.customDescription
                    ? trimEnd(this.customDescription, ':')
                    : 'Please be sure to use these tags in your post';
            }
        }
    };
</script>
